import {Component, Inject, OnInit} from '@angular/core';
import { NgControl, UntypedFormControl } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { cloneDeep, get } from 'lodash-es';
import { combineLatest, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss']
})

export class CommonDialogComponent implements OnInit {
  reloadTableSelection: string[];
  selectedWarehouse: string;
  groupData: any;
  searchStr = '';
  warehouseDataset: any;
  disableGroupFormSubmit: boolean;
  filter: UntypedFormControl = new UntypedFormControl('');
  applyTemplateChanges: string;
  disableApplyTemplateChangeButton = true;
  public connectors$: any;
  customAlignStart: boolean = false;

  constructor(private thisDialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      data.buttons.reverse();
      (this.data.warehouseList !== undefined)? this.warehouseDataset = [...this.data.warehouseList]:'';//console.log(this.warehouseDataset,"Helo")
      this.customAlignStart = this.data?.customAlignStart;
  }

  ngOnInit() {
    if (this.data.group) {
      this.groupData = this.data.groupData ? cloneDeep(this.data.groupData) : {};
    }

    if(this.data.templateConnectors) {
       this.connectors$ = combineLatest(
          of(this.data.connectors),
          this.filter.valueChanges.pipe(startWith(''))
      ).pipe(
        map(([connectors, filterString]) => connectors.filter((connector: any) => connector.displayName.toLowerCase().indexOf(filterString.toLowerCase()) !== -1))
      );
    }

  }

  filterWarehouseList() {

    if(this.searchStr !== '') {
      this.warehouseDataset = this.data.warehouseList.filter( w => w.name.includes(this.searchStr) )
    } else {
      this.warehouseDataset = [...this.data.warehouseList]
    }

  }

  selectWarehouse() {
    this.data.buttons.forEach(button => {
      if (button.type === 'disabled') {
        button.type = 'redirect'
      }
    });
  }

  ifMessage(){
    return (this.searchStr !== '' && (this.data.warehouseList.find(w => w.name.includes(this.searchStr) ) === undefined ) )
  }

  onClose(data, password = false) {
    data["reloadTableSelection"] = this.reloadTableSelection
    data["selectedWarehouse"]= this.selectedWarehouse;
    if (this.data.group) {
      data = {...data, ...this.groupData};
    }
    if (!password) {
      this.thisDialogRef.close(data);
    }  else {
      this.thisDialogRef.close({data, "password": password});
    }

  }

  onCloseDialogNO() {
  this.thisDialogRef.close('NO');
  }

  onCloseDialog() {
  this.thisDialogRef.close('PROCEED');
  }

  onConfirm(): void {
    this.thisDialogRef.close(true); // Confirm action
  }

  onCancel(): void {
    this.thisDialogRef.close(false); // Cancel action
  }
  onGroupFormChange(event, groupName: NgControl) {
    const value = get(groupName, 'value');
    if (value === get(this.data, 'companyName')) {
      groupName.control.setErrors({'companyName': true});
    } else if (value &&  value.length >= 50) {
      groupName.control.setErrors({'maxLength': true});
    }
    this.disableGroupFormSubmit = !groupName.valid;
  }


  onApplyTemplateChangeClose(event) {
    this.thisDialogRef.close({...event, applyChanges: this.applyTemplateChanges});
  }


  templateTypeHandler(connector) {
    this.thisDialogRef.close({type: 'templateConnectors', connector});
  }

  applyTemplateChangeHandler(event) {
    const response = get(event, 'target.value');
    if (response) {
      this.disableApplyTemplateChangeButton = false;
    }
  }

}

